import { useListEntityApi } from '@/common/api/listEntityApi';
import type { MappingTrace } from 'shared/products/mapping/domain/mappingTrace';

export interface ListMappingTracesResponse {
  ok: true;
  mappingTraces: MappingTrace[];
}

export function useListMappingTraces() {
  return useListEntityApi<ListMappingTracesResponse>({
    url: 'mappingTrace',
    translate: (t) => t.products.actions.fetchMany,
    async processOk(response) {
      const json = await response.json() as MappingTrace[];

      json.sort((a, b) => b.createdAtUtc.localeCompare(a.createdAtUtc));

      return {
        ok: true,
        mappingTraces: json,
      };
    },
  });
}
